export const getApiBaseURL = () => useRuntimeConfig().public.apiBaseUrl as string;
